export default "__VITE_ASSET__CAwtXlJC__"